import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'app-comment-item',
  templateUrl: './comment-item.component.html',
  styleUrls: ['./comment-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentItemComponent implements OnInit {
  @Input()
  comment;

  get title() {
    return this.comment && this.comment.follow
      ? this.comment.follow.name
      : this.comment && this.comment.product
        ? this.comment.product.name
        : null;
  }

  get author() {
    return this.comment && this.comment.user && this.comment.user.name;
  }

  get message() {
    return this.comment && this.comment.message;
  }

  constructor() {}

  ngOnInit() {}
}
